import { Button } from '@lt/components';
import LoaderIcon from '@lt/components/icons-react/rebrand/Loader';
import cn from 'classnames';
import React, { useEffect, useState } from 'react';
import styles from './submitOrderButton.module.css';

interface SubmitOrderButtonProps {
  onClick: () => void;
  isLoading?: boolean;
  disabled?: boolean;
  children: React.ReactNode;
  isMobile: boolean;
  className?: string;
}

const SubmitOrderButton: React.FC<SubmitOrderButtonProps> = ({
  onClick: pay,
  isLoading = false,
  disabled = true,
  children,
  isMobile = false,
  className,
}) => {
  const [isAllowed, setIsAllowed] = useState(true);

  const onClick = () => {
    setIsAllowed(false);
    pay();
  };

  useEffect(() => {
    setIsAllowed(!disabled);
  }, [disabled]);
  return (
    <Button
      className={cn(styles.button, { [styles.desktop]: !isMobile }, className)}
      type="button"
      primary
      disabled={!isAllowed}
      onClick={onClick}
      size="flex"
      isMobile={isMobile}
      data-at-package-submit-order-button
    >
      {isLoading ? <LoaderIcon className={styles.loader} /> : children}
    </Button>
  );
};

export default SubmitOrderButton;
